"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectHubClient = void 0;
class DirectHubClient {
    constructor(data) {
        this.data = data;
        if (!data.token) {
            throw new Error("Invalid token");
        }
    }
    get token() {
        return this.data.token;
    }
    get id() {
        throw new Error("Not implemented");
    }
    updateData(data) {
        Object.assign(this.data, data);
        return true;
    }
    signal(type) {
    }
}
exports.DirectHubClient = DirectHubClient;
//# sourceMappingURL=DirectHubClient.js.map